const multiInstanceScreens = ['salesorder', 'shiptoopportunities']
export default route => multiInstanceScreens.includes(route)